import { render, staticRenderFns } from "./demandList.vue?vue&type=template&id=31dd7c62&scoped=true"
import script from "./demandList.vue?vue&type=script&lang=js"
export * from "./demandList.vue?vue&type=script&lang=js"
import style0 from "./demandList.vue?vue&type=style&index=0&id=31dd7c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd7c62",
  null
  
)

export default component.exports